// -*-mode: rjsx -*-
// REACT
import React, { Component } from "react"
import PropTypes from "prop-types"
// eslint-disable-next-line
import clsx from "clsx"

// ROUTER
// eslint-disable-next-line
import { Link, Redirect } from "react-router-dom"
import LinkCore from "@material-ui/core/Link";

// MUI
// eslint-disable-next-line
import { makeStyles, withStyles } from "@material-ui/core/styles"
import CssBaseline from "@material-ui/core/CssBaseline"
import Typography from "@material-ui/core/Typography"
//import ForwardIcon from '@material-ui/icons/Forward';
import ForwardIcon from '@material-ui/icons/ArrowForwardIos';
import grey from "@material-ui/core/colors/grey"


// FLASH
import FlashLogo from "../static/images/lightning-logo-transparent.png"

const styles = theme => ({


    fabDiv: {
        // position: "relative",
        // bottom: 50,
        // paddingRight: 20,
        display: "flex",
        justifyContent: "flex-end",
    },
    
    fab: {
        position: "fixed",
        //        bottom: theme.spacing(8),
        //        bottom: "5%",
        //        right: theme.spacing(1),
        //        left: "75%",
        // marginLeft: 400,
        //        marginLeft: "65%",
        //        marginTop: "-20%",
        zIndex: 10,

        width: 60,
        height: 60,


        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            // marginTop: "-10%",
            bottom: "5%",
            right: "8%",
        },

        
        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            //            left: "60%",
            //            bottom: "20%",
            //            marginLeft: 400,
            //            marginLeft: "25%",
            //            marginTop: "0%",
        },

    },
    
    fabBlue: {
        color: theme.palette.common.white,
        //backgroundColor: theme.palette.custom.scrollDark,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.primary.light,
        },
    },
    
    //
    // proper styles
    //

    "@keyframes loginAnimation":  {
        "0%": {
            opacity: 1,
        },

        "40%": {
            opacity: 1,
        },
        
        "99%": {
            opacity: 0,
            width: "100%",
            height: "100%",
        },

        "100%": {
            opacity: 0,
            width: 0,
            height: 0,
        }
    },

    
    logoRoot: {
        position: "fixed",
        top: 0,
        left: 0,
        
        display: "flex",
        alignItems: "center", // vertical center
        justifyContent: "center", // horizontal center

        width: "100%",
        height: "100%",
        background: theme.palette.primary.main,
        zIndex: 1000,

        animationName: "$loginAnimation",
        animationDuration: "4s",
        animationFillMode: "forwards",

        userSelect: "none",
        
    },

    logoImg: {

        width: "40%",
        maxWidth: 200,

        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            // marginTop: -350,
            // marginTop: "-15%",
        },
        
    },

    // text page
    introRoot: {
        position: "fixed",
        top: 0,
        left: 0,
        
        display: "flex",
        flexDirection: "column",
        alignItems: "center", // vertical center
        justifyContent: "center", // horizontal center

        width: "100%",
        height: "100%",

        backgroundColor: "#FFFFFF",

        userSelect: "none",
        
    },

    introText: {
        margin: "auto",
        marginTop: 10,
        //marginTop: "18%",
        //
        // desktop - if more than 600
        //
        //marginTop: "3em",
        [theme.breakpoints.up("md")]: {
            //marginTop: "5%",
            marginTop: "6em",
        },
        paddingLeft: 40,
        paddingRight: 40,
        maxWidth: 400,
        backgroundColor: "#FFFFFF",
        zIndex: 1000
    },

    titleText: {
        color: theme.palette.primary.main,
        fontSize: 21,
    },

    continueText: {
        marginBottom: "0px",
        marginRight: "18px",
        color: theme.palette.primary.main,
        fontSize: "16px",
        fontWeight: "700"
    },
    

    titleLogo: {
        marginRight: 5,
        paddingBottom: 0,
        width: 62,
    },

    forwardArrow_old: {
        marginTop: -20,        
        width: 120,
        height: 120,
        color: theme.palette.primary.main,

        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            marginTop: -72,
            marginLeft: -230,        
        },
    },

    forwardButton: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        //justifyItems: "flex-center",
        width: "51px",
        height: "51px",
        borderRadius: "50%",
        backgroundColor: theme.palette.primary.main,
        boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)",
        "&:hover": {
            backgroundColor: "#438cffc2"
        }
    },
    
    forwardArrow: {
        //marginTop: -20,        
        //width: "25",
        //height: "25",
        fontSize: "28px",
        color: "white",
        marginLeft: "4px",
        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
//            marginTop: -72,
//            marginLeft: -230,        
        },
    }
    

})

let LogoComponent = withStyles(styles, { name: "LogoComponent" })(
    class LogoComponentBasis extends Component {
        render() {

            const { classes, match } = this.props
            
            return(
                <div className={classes.logoRoot}>
                  <img alt="logo" src={FlashLogo} className={classes.logoImg}/>
                </div>
            )
        }
    }
)


let IntroComponent = withStyles(styles, { name: "IntroComponent" })(
    class IntroComponentBasis extends Component {

        // yes, we can redirect from children!

        state = {
            redirectToRegiser: false,
            debugLayout: false
        }

        handleStartClick = () => {
            const { history, registerUrl } = this.props
            console.log("<Intro>: handleStartClick(): history =", history)
            //this.setState({redirectToRegister: true})
            history.push(registerUrl)
        }
        
        render() {

            const { classes, match, history } = this.props
            console.log("<Intro>: render(): history =", history)
            console.log("<Intro>: render(): match =", match)
            
            // redirects first
            if (this.state.redirectToRegister) {
                return <Redirect push to="/register"/>
            }
            
            
            return(
                <div className={classes.introRoot}>
                  <div className={classes.introText}>

                    <div style={{display: "flex", justifyContent: "center", alignItems: "flex-center", flexGrow: 1}}>
                      <div className={classes.titleText}><b>Welcome to</b></div>
                    </div>
                    
                    <div style={{display: "flex", justifyContent: "center", alignItems: "flex-center", flexGrow: 1}}>
                      <div className={classes.titleText}><b>Actionable Feedback!</b></div>
                    </div>

                    <div style={{marginTop: 20}}/>

                    {/*
                    <div style={{ textAlign: "center"}}>
                      <img alt="logo" src={FlashLogo} style={{ height: 80 }}/>
                    </div>
                     */}

                    <div style={{ textAlign: "center"}}>
                      <img alt="logo" src={FlashLogo} style={{ height: 40 }}/>
                    </div>
                    

                    <div style={{marginTop: 10}}/>
                    {/*
                    <div style={{display: "flex", justifyContent: "center", alignItems: "flex-center", flexGrow: 1}}>
                      <div style={{color: "black"}} className={classes.titleText}><b>Lightning</b></div>
                    </div>
                     */}


                    <div style={{display: "flex", justifyContent: "center", alignItems: "flex-center", flexGrow: 1}}>
                      <div style={{fontSize: 15, color: "black"}} className={classes.titleText}><b>Lightning</b></div>
                    </div>

                    <div style={{marginTop: -20, display: "flex", justifyContent: "center", alignItems: "flex-center", flexGrow: 1}}>
                      <div style={{color: "#f8d337"}} className={classes.titleText}><b><u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</u></b></div>
                    </div>

                    

                    <div style={{marginTop: 10}}/>
                    
                    {/* AAA START */}
                    <Typography variant="body1">
                      {/*
                      <div style={{display: "inline", fontSize: "1.5em", color: "green" }}>
                        <div style={{display: "inline", verticalAlign: -3}}>
                          <b><i>&#10004;</i></b>
                        </div>
                      </div>
                       */}
                      <div style={{display: "inline"}}>&nbsp;&nbsp;&nbsp;Gives Representatives a clear view of the concerns of their constituents on major issues of the day 24/7</div>
                    </Typography>

                    {/*
                    <Typography variant="body1">
                      <span style={{fontSize: "1.5em", color: "green"}}><b><i>&#10004;</i></b></span>&nbsp;&nbsp;Every day
                    </Typography>
                     */}

                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      <span style={{fontSize: "1.5em", color: "green"}}><b><i>&#10004;</i></b></span>&nbsp;&nbsp;Helps them represent you better
                    </Typography>


                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      <span style={{fontSize: "1.5em", color: "green"}}><b><i>&#10004;</i></b></span>&nbsp;&nbsp;Replaces thousands of emails with your voice
                    </Typography>

                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      <span style={{fontSize: "1.5em", color: "green"}}><b><i>&#10004;</i></b></span>&nbsp;&nbsp;Strengthens democracy
                    </Typography>
                     {/* AAA END*/}


                    {/* BBB START 
                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      <b><i>Lightning</i></b> gives Representatives a view of concerns &amp; opinions of their
                      constituents - on major issues of the day, every day.
                    </Typography>
                    
                    
                    <div style={{marginTop: 15}}/>

                    <Typography variant="body1">
                      &#10148;&nbsp;&nbsp;They can’t understand constituents, now
                    </Typography>
                    <Typography variant="body1" style={{paddingLeft: "2em"}}>
                      &#8226;&nbsp;&nbsp;They get thousands of email = just millions of words
                    </Typography>

                    <div style={{marginTop: 15}}/>
                    <Typography variant="body1">
                      &#10148;&nbsp;&nbsp;<b><i>Lightning</i></b> helps them represent you
                    </Typography>


                    <div style={{marginTop: 15}}/>
                    <Typography variant="body1">
                      &#10148;&nbsp;&nbsp;<b><i>Lightning</i></b> strenghens democracy
                    </Typography>
                    BBB END*/}
                    
                    <div style={{marginTop: 30}}/>
                    
                    <span onClick={this.handleStartClick}
                          style={{ cursor: "pointer" }}>

                      <div style={{
                          backgroundColor: this.state.debugLayout ? grey[800] : "inherit",
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                          //justifyContent: "space-between",
                          justifyContent: "center",
                          alignItems: "center",
                          marginRight: "auto"
                      }}>
                        <div style={{fontSize: 22}} className={classes.continueText}>Get Started</div>
                        <div className={classes.forwardButton}>
                          <ForwardIcon className={classes.forwardArrow}/>
                        </div>                
                      </div>
                    </span>
                  </div>
                </div>
            )
        }
    }
)

class Intro extends Component {

    render() {
        
        // const { classes } = this.props

        const { match, history } = this.props
        console.log("<Intro>: render(): match =", match)
        console.log("<Intro>: render(): history =", history)

        let registerUrl = "/register" // default
        if(match) {
            const { driveSlug } = match.params
            if(driveSlug) {
                registerUrl = `/drives/${driveSlug}/register`
            }
        }

	return(
            <React.Fragment>
	      <CssBaseline/>
              <LogoComponent/>
              <IntroComponent history={history} registerUrl={registerUrl}/>
            </React.Fragment>
	)
    }
}

Intro.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles, { name: "Intro" })(Intro)

